import React, { useEffect, useState } from "react";
import { LanguageConstants } from "../constants/LanguageConstants";
import fillStart from "../Assets/images/star.png";
import halfStart from "../Assets/images/star-outline.png";
import useMakeRequest from "../utils/ApiHelper";
import { ApiConstants } from "../constants/ApiConstants";
import { toast } from "react-toastify";
import FrontLoader from "../component/layout/FrontLoader";
import { getFromStorage } from "../utils/Helper";
import { normalizeReviewCountryCode } from "../utils/reviewCountryDisplay";

type StarRatingProps = {
  value: number;
  onChange: (value: number) => void;
};

function StarRating({ value, onChange }: StarRatingProps) {
  return (
    <div className="star-rating">
      {Array.from({ length: 5 }, (_, i) => (
        <img
          key={i}
          src={i < value ? fillStart : halfStart}
          alt={`Star ${i + 1}`}
          onClick={() => onChange(i + 1)}
          onMouseEnter={(e: React.MouseEvent<HTMLImageElement>) => {
            const stars = Array.from(
              e.currentTarget.parentElement?.querySelectorAll("img") ?? [],
            );
            stars.forEach((star, index) => {
              (star as HTMLImageElement).src =
                index <= i ? fillStart : halfStart;
            });
          }}
          onMouseLeave={(e: React.MouseEvent<HTMLImageElement>) => {
            const stars = Array.from(
              e.currentTarget.parentElement?.querySelectorAll("img") ?? [],
            );
            stars.forEach((star, index) => {
              (star as HTMLImageElement).src =
                index < value ? fillStart : halfStart;
            });
          }}
        />
      ))}
    </div>
  );
}

const SurveyModal = (props: any) => {
  const [shoppingExperience, setShoppingExperience] = useState(0);
  const [productCorresponds, setProductCorresponds] = useState(0);
  const [paymentExperience, setPaymentExperience] = useState(0);
  const [content, setContent] = useState("");
  const SurveyAdd = useMakeRequest();

  const handelSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (
      content.trim().length <= 0 ||
      shoppingExperience === 0 ||
      paymentExperience === 0 ||
      productCorresponds === 0
    ) {
      return toast.error(LanguageConstants?.overall_experience);
    }

    const profile = getFromStorage({ key: "user_data" })?.data;
    const country_code =
      normalizeReviewCountryCode(profile?.phone_country_code) ??
      normalizeReviewCountryCode(profile?.country_code) ??
      null;

    const payload = {
      order_id: props?.data?.uuid,
      content: content.trim(),
      payment_experience: paymentExperience,
      shopping_experience: shoppingExperience,
      product_received_corresponds: productCorresponds,
      country_code,
    };
    SurveyAdd.makeRequest({
      payload,
      url: ApiConstants?.QuotesAddSurvery,
      toastStatus: true,
    });
  };

  useEffect(() => {
    if (SurveyAdd?.status) {
      props?.setSurveyShow(false);
      props?.setApiRefresh(true);
    }
  }, [SurveyAdd.status]);

  return (
    <>
      <style>{`
.survey-form {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.question-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.question-label {
  font-size: 15px;
  color: #000;
  font-weight: 500;
  line-height: 1.5;
}

.survey-title{
  font-size: 16px;
  line-height: 1.5;
}

.star-rating {
  display: flex;
  gap: 8px;
}

.star-rating img {
  width: 20px;
  cursor: pointer;
}

.review-input {
  width: 100%;
  padding: 14px;
  border: 1px solid transparent;
  border-radius: 10px;
  font-size: 14px;
  font-family: inherit;
  resize: none;
  background: #ECE5FF;
}

.review-input::placeholder {
  color: #9793A2;
}

.review-input:focus {
  outline: none;
  border-color: #5A32C7;
}

.submit-btn {
  width: 100%;
  padding: 16px;
  background-color: #7c3aed;
  color: #ffffff;
  border: none;
  border-radius: 28px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 8px;
}

.submit-btn:hover {
  background-color: #6d28d9;
}

.submit-btn:active {
  transform: scale(0.98);
}
.com-modal .modal-dialog .modal-content .modal-header .modal-title{
   font-size: 16px;
   font-weight: 600;
   text-align: left;
   line-height: normal;
   color: #5A32C7;
 }
.com-modal .modal-dialog .modal-content .modal-header .btn-close{
  color: #000;
  font-size: 11px;
  margin: 0;
}
`}</style>

      {SurveyAdd?.loading ? <FrontLoader /> : null}
      <div
        className="modal fade com-modal show"
        id="surveymessage"
        aria-labelledby="editMessageProductModalLabel"
        aria-hidden="false"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-0 px-4 pb-3">
              <h5 className="modal-title" id="editMessageProductModalLabel">
                {LanguageConstants?.SURVEY}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => props?.setSurveyShow(false)}
              >
                <i className="icon-close" />
              </button>
            </div>
            <div className="modal-body px-4">
              <div className="survey-container">
                <p className="survey-title">{LanguageConstants?.SURVEY_TITLE}</p>
                <form className="survey-form" onSubmit={handelSubmit}>
                  <div className="question-group">
                    <label className="question-label">
                      {LanguageConstants?.QUESTIONONE}
                    </label>
                    <StarRating
                      value={shoppingExperience}
                      onChange={setShoppingExperience}
                    />
                  </div>

                  <div className="question-group">
                    <label className="question-label">
                      {LanguageConstants?.QUESTIONTWO}
                    </label>
                    <StarRating
                      value={productCorresponds}
                      onChange={setProductCorresponds}
                    />
                  </div>

                  <div className="question-group">
                    <label className="question-label">
                      {LanguageConstants?.QUESTIONTHREE}
                    </label>
                    <StarRating
                      value={paymentExperience}
                      onChange={setPaymentExperience}
                    />
                  </div>

                  <div className="question-group">
                    <label className="question-label">
                      {LanguageConstants?.QUESTIONFOUR}
                    </label>
                    <textarea
                      className="review-input"
                      placeholder={
                        LanguageConstants?.SURVEY_REVIEW_PLACEHOLDER
                      }
                      rows={4}
                      value={content}
                      onChange={(e) => setContent(e.target.value)}
                    />
                  </div>
                    <div className="row">
                      <div className="col-md-7 mx-auto">
                        <button type="submit" className="round-btn w-100">
                          {LanguageConstants?.SURVEY_SEND}
                        </button>
                      </div>
                    </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SurveyModal;
